import React from 'react';
import { useMessageContext } from 'stream-chat-react';
import AppointmentCard from './AppointmentCard';
import CustomAvatar from "./shared/CustomAvatar";
import { shouldShowAvatar } from "../utils/shouldShowAvatar";
import { DAY_THRESHOLD } from "../constants";
import { formatDaysAgo } from "../utils/chatUtils";
import styles from '../styles/CustomMessage.module.css';

const CustomMessageAppointment = (props) => {
  const { message } = useMessageContext();

  // Null-safety checks
  if (!message || !props.client) {
    return null;
  }

  const { isMyMessage, isSender } = props;
  const isMyMessageValue = typeof isMyMessage === 'function' ? isMyMessage() : Boolean(isMyMessage);

  return (
    <div className={isMyMessageValue ? "flex-col" : "flex"}>
      <div className={`str-chat__message str-chat__message-simple ${isMyMessageValue ? 'str-chat__message--me' : 'str-chat__message--other'}`}>
        {!isMyMessageValue && (
          <CustomAvatar
            shouldShowAvatar={shouldShowAvatar}
            timeThreshold={DAY_THRESHOLD}
          />
        )}
        <div className="str-chat__message-inner">
          <div
            className={`str-chat__message-bubble`}
            style={isMyMessageValue ? { backgroundColor: 'var(--input)' } : {}}
          >
            <AppointmentCard
              message={message}
              isMyMessage={isMyMessageValue}
              isSender={isSender}
              client={props.client}
            />
          </div>
        </div>
        <div className={`str-chat__message-metadata ${styles.customTimestamp}`}>
          {formatDaysAgo(message.created_at)}
        </div>
      </div>
    </div>
  );
};

export default React.memo(CustomMessageAppointment);